const languages = ['de', 'en', 'es', 'fr', 'it', 'pt', 'da']

module.exports = languages
